module.exports = __webpack_public_path__ + "static/media/iconFour.31ad0354.svg";